import {
    FETCH_UPDATE_COMMON_REQUEST,
    FETCH_UPDATE_COMMON_SUCCESS,
    FETCH_UPDATE_COMMON_FAILURE,
    SET_UPDATE_COMMON
} from '../../actions/commons/update-commons-actions';

const initialState = {
    updatedCommonr: null,
    common: null,
    isLoading: false,
    error: null,
};

const CLEAR_DATA = "CLEAR_DATA";
const UpdateCommonReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case FETCH_UPDATE_COMMON_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case SET_UPDATE_COMMON:
            return {
                ...state,
                isLoading: false,
                error: null,
                common: { ...action.payload }
            };
        case FETCH_UPDATE_COMMON_SUCCESS:
            return {
                ...state,
                isLoading: false,
                updatedCommon: action.payload[0],
            };
        case FETCH_UPDATE_COMMON_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };
        case CLEAR_DATA:
            return {
                ...initialState
            };
        default:
            return state;
    }
};

export default UpdateCommonReducer;